


















import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import Footer from './Footer.vue';
import Header from './Header.vue';
import {imgStructure} from './imageInfo';
import InstagramApi from '../services/api/Instagram';

export default Vue.extend({
  data() {
    return {
      images:<Array<imgStructure>>[],
      isLoading:<boolean>false,
      currentImageIndex:<number>0,
    }
  },
  components: {
    Footer, Header
  },
  computed: {
    isNextImage(): boolean {
        return this.$store.state.lightbox.next_img
    },
    isPrevImage(): boolean {
        return this.$store.state.lightbox.prev_img
    }
  },
  watch: {
    /**
     * shows next image if isNextImage is true and if the current image's index isn't the last one
     */
    isNextImage: function() {
      if (this.isNextImage && this.currentImageIndex != (this.images.length - 1)) {
        this.displayImgModal(this.currentImageIndex + 1)
        this.$store.commit('show_next_img', {
            state: false})
      } else {
        this.$store.commit('show_next_img', {
            state: false})        
      }
    },
    /**
     * shows prev image if isPrevImage is true and if the current image's index isn't 0
     */    
    isPrevImage: function() {
      if (this.isPrevImage && this.currentImageIndex != 0) {
        this.displayImgModal(this.currentImageIndex - 1)
        this.$store.commit('show_prev_img', {
            state: false})
      } else {
        this.$store.commit('show_prev_img', {
            state: false})        
      }
    }
  },
  methods: {
    /**
     * Get images from the instagram API
     * sets result to this.images
     */
    getImages(): void {
      this.isLoading = true;
      InstagramApi.getInstagramImages().then((images:imgStructure[])=> {
        this.images = images;
        this.isLoading = false;
      })
    },
    /**
     * Uses pagination property of instagram API to fetch the next page
     * appends result in this.images
     */ 
    loadMoreImages(): void{
      this.isLoading = true;
      InstagramApi.loadMoreInstagramImages(this.images).then((images:imgStructure[])=> {
        this.images = images;
        this.isLoading = false;
      })          
    },
    /**
     * Displays the current image at index 'index' of this.images
     * @param {number} index target image index to display
     */
    displayImgModal(index:number): void{
      this.currentImageIndex = index
      let image = this.images[index]
      this.$store.commit('show_lightbox')
      this.$store.commit('set_lightbox_img', {
        img_src: image.img_src})
      this.$store.commit('push_img', {
        carousel: image.carousel_img
      })
      this.$store.commit('set_lightbox_img_info', {
        info: {
          img_text: image.img_text,
          img_likes: image.img_likes
        }
      })    
    }
  },
  mounted(){
    this.getImages()
  }
})
